// extracted by mini-css-extract-plugin
module.exports = {"rename-asset-input":"style_rename-asset-input__MO0BK"};